import { render, staticRenderFns } from "./ServiceTakerAllocationRegisterRollover.vue?vue&type=template&id=0b12ff40&"
import script from "./ServiceTakerAllocationRegisterRollover.vue?vue&type=script&lang=js&"
export * from "./ServiceTakerAllocationRegisterRollover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports